import { FastField } from "formik";
import { FormGroup } from "../../../form/group";
import { Switch } from "../../../form/switch/Switch";
import * as React from "react";
export const FastFieldSwitch = ({ name, title, help, setValue }) => (React.createElement(FastField, { name: name, render: ({ field }) => (React.createElement(FormGroup, { title: title, help: help },
        React.createElement(Switch, { id: `${name}-field-switch`, checked: field.value, onChange: (e) => setValue(name, e.target.checked) }))) }));
//# sourceMappingURL=index.js.map